// src/components/user/PerfilUsuario.js
import React, { useEffect, useState } from 'react';
import { auth, db } from '../../firebase/config';
import {
  doc,
  getDoc,
  collection,
  addDoc,
  serverTimestamp,
  updateDoc,
  query,
  orderBy,
  deleteDoc,
  getDocs
} from 'firebase/firestore';
import {
  FaUser,
  FaHeartbeat,
  FaUtensils,
  FaDumbbell,
  FaCheck,
  FaSpinner
} from 'react-icons/fa';

const APP_PRIMARY = '#b03060';

const PerfilUsuario = () => {
  const [uid, setUid] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');
  const [mensajeExito, setMensajeExito] = useState(false);

  const [datos, setDatos] = useState({
    motivo: '',
    nombreCompleto: '',
    email: '',
    genero: '',
    edad: '',
    peso: '',
    altura: '',
    imc: '',
    circunferenciaCintura: '',
    horasSueno: '',
    actividadOcupacion: '',
    objetivos: '',
    antecedentesMedicos: '',
    especificarAntecedentes: '',
    medicamentos: '',
    especificarMedicamentos: '',
    tieneAlergia: '',
    especificarAlergia: '',
    bebeAlcohol: '',
    fuma: '',
    practicaDeporte: '',
    detalleDeporteFrecuencia: '',
    experienciaPesas: '',
    objetivoEntrenamiento: '',
    nutricionista: '',
    interesNutricion: '',
    comidas: {
      desayuno: '',
      almuerzo: '',
      once: '',
      cena: '',
      entreComidas: ''
    },
    contratoSemanal: '',
    problemasPosturales: {
      escoliosis: false,
      cifosis: false,
      hiperlordosis: false,
      ptosisAbdominal: false,
      toraxEscavado: false,
      escapulasAladas: false,
      rodillasEnX: false,
      piePlano: false,
      pieCavo: false,
      diferenciaExtremidades: false,
      otrosPosturales: false,
      descripcionOtrosPosturales: ''
    }
  });

  // Escucha el estado de sesión sin disparar errores falsos de sincronización
  useEffect(() => {
    const unsub = auth.onAuthStateChanged((user) => {
      if (user) {
        setUid(user.uid);
      } else {
        setCargando(false);
        setError('Por favor inicia sesión para ver tu ficha.');
      }
    });
    return () => unsub();
  }, []);

  // Carga inicial de datos cuando el UID está disponible
  useEffect(() => {
    if (!uid) return;

    const cargarDatos = async () => {
      try {
        const docRef = doc(db, 'usuarios', uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          const ficha = data.fichaActual;

          if (ficha) {
            setDatos({
              motivo: ficha.motivo || '',
              nombreCompleto: ficha.nombreCompleto || data.nombre || '',
              email: ficha.email || data.email || auth.currentUser?.email || '',
              genero: ficha.genero || '',
              edad: ficha.edad || '',
              peso: ficha.peso || '',
              altura: ficha.altura || '',
              imc: ficha.imc || '',
              circunferenciaCintura: ficha.circunferenciaCintura || '',
              horasSueno: ficha.horasSueno || '',
              actividadOcupacion: ficha.actividadOcupacion || '',
              objetivos: ficha.objetivos || '',
              antecedentesMedicos: ficha.antecedentesMedicos || '',
              especificarAntecedentes: ficha.especificarAntecedentes || '',
              medicamentos: ficha.medicamentos || '',
              especificarMedicamentos: ficha.especificarMedicamentos || '',
              tieneAlergia: ficha.tieneAlergia || '',
              especificarAlergia: ficha.especificarAlergia || '',
              bebeAlcohol: ficha.bebeAlcohol || '',
              fuma: ficha.fuma || '',
              practicaDeporte: ficha.practicaDeporte || '',
              detalleDeporteFrecuencia: ficha.detalleDeporteFrecuencia || '',
              experienciaPesas: ficha.experienciaPesas || '',
              objetivoEntrenamiento: ficha.objetivoEntrenamiento || '',
              nutricionista: ficha.nutricionista || '',
              interesNutricion: ficha.interesNutricion || '',
              contratoSemanal: ficha.contratoSemanal || '',
              comidas: {
                desayuno: ficha.comidas?.desayuno || '',
                almuerzo: ficha.comidas?.almuerzo || '',
                once: ficha.comidas?.once || '',
                cena: ficha.comidas?.cena || '',
                entreComidas: ficha.comidas?.entreComidas || ''
              },
              problemasPosturales: {
                escoliosis: ficha.problemasPosturales?.escoliosis || false,
                cifosis: ficha.problemasPosturales?.cifosis || false,
                hiperlordosis: ficha.problemasPosturales?.hiperlordosis || false,
                ptosisAbdominal: ficha.problemasPosturales?.ptosisAbdominal || false,
                toraxEscavado: ficha.problemasPosturales?.toraxEscavado || false,
                escapulasAladas: ficha.problemasPosturales?.escapulasAladas || false,
                rodillasEnX: ficha.problemasPosturales?.rodillasEnX || false,
                piePlano: ficha.problemasPosturales?.piePlano || false,
                pieCavo: ficha.problemasPosturales?.pieCavo || false,
                diferenciaExtremidades: ficha.problemasPosturales?.diferenciaExtremidades || false,
                otrosPosturales: ficha.problemasPosturales?.otrosPosturales || false,
                descripcionOtrosPosturales: ficha.problemasPosturales?.descripcionOtrosPosturales || ''
              }
            });
          } else {
            // Usuario sin ficha previa: prellenar nombre y correo si existen
            setDatos((prev) => ({
              ...prev,
              nombreCompleto: `${data.nombre || ''} ${data.apellido || ''}`.trim(),
              email: data.email || auth.currentUser?.email || ''
            }));
          }
        }
      } catch (err) {
        console.error(err);
        setError('Error al cargar la información del perfil.');
      } finally {
        setCargando(false);
      }
    };

    cargarDatos();
  }, [uid]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDatos((prev) => ({ ...prev, [name]: value }));
    setError('');
  };

  const handlePosturalChange = (e) => {
    const { name, checked, value } = e.target;
    if (name === 'descripcionOtrosPosturales') {
      setDatos((prev) => ({
        ...prev,
        problemasPosturales: { ...prev.problemasPosturales, [name]: value }
      }));
    } else {
      setDatos((prev) => ({
        ...prev,
        problemasPosturales: { ...prev.problemasPosturales, [name]: checked }
      }));
    }
    setError('');
  };

  const handleComidaChange = (e) => {
    const { name, value } = e.target;
    setDatos((prev) => ({
      ...prev,
      comidas: { ...prev.comidas, [name]: value }
    }));
    setError('');
  };

  const validarFormulario = () => {
    const camposObligatorios = [
      'motivo',
      'nombreCompleto',
      'email',
      'genero',
      'edad',
      'peso',
      'altura',
      'horasSueno',
      'actividadOcupacion',
      'tieneAlergia',
      'bebeAlcohol',
      'fuma',
      'practicaDeporte',
      'experienciaPesas',
      'objetivoEntrenamiento',
      'nutricionista',
      'interesNutricion',
      'contratoSemanal',
      'antecedentesMedicos',
      'medicamentos'
    ];

    for (let campo of camposObligatorios) {
      const valor = datos[campo];
      if (typeof valor === 'string' && valor.trim() === '') return false;
    }

    if (datos.antecedentesMedicos === 'si' && datos.especificarAntecedentes.trim() === '') return false;
    if (datos.medicamentos === 'si' && datos.especificarMedicamentos.trim() === '') return false;
    if (datos.tieneAlergia === 'si' && datos.especificarAlergia.trim() === '') return false;

    for (let meal of ['desayuno', 'almuerzo', 'once', 'cena', 'entreComidas']) {
      if (!datos.comidas[meal] || datos.comidas[meal].trim() === '') return false;
    }

    if (datos.problemasPosturales.otrosPosturales && datos.problemasPosturales.descripcionOtrosPosturales.trim() === '') {
      return false;
    }

    return true;
  };

  const MAX_HISTORIAL = 5;

  const handleGuardar = async () => {
    setError('');
    setMensajeExito(false);

    if (!validarFormulario()) {
      setError('Por favor completa todos los campos obligatorios marcados con asterisco (*).');
      return;
    }

    setGuardando(true);

    try {
      const userRef = doc(db, 'usuarios', uid);
      const snap = await getDoc(userRef);

      if (!snap.exists()) {
        throw new Error('Usuario no encontrado');
      }

      const fichaAnterior = snap.data().fichaActual || {};
      const cambios = {};

      // Detección de cambios
      Object.keys(datos).forEach((campo) => {
        if (typeof datos[campo] !== 'object' && fichaAnterior[campo] !== datos[campo]) {
          cambios[campo] = { antes: fichaAnterior[campo] ?? '-', despues: datos[campo] };
        }
      });

      Object.keys(datos.comidas).forEach((campo) => {
        if (fichaAnterior.comidas?.[campo] !== datos.comidas[campo]) {
          cambios[`comidas.${campo}`] = { antes: fichaAnterior.comidas?.[campo] ?? '-', despues: datos.comidas[campo] };
        }
      });

      Object.keys(datos.problemasPosturales).forEach((campo) => {
        if (fichaAnterior.problemasPosturales?.[campo] !== datos.problemasPosturales[campo]) {
          cambios[`problemasPosturales.${campo}`] = { antes: fichaAnterior.problemasPosturales?.[campo] ?? '-', despues: datos.problemasPosturales[campo] };
        }
      });

      // Registro en historial
      if (Object.keys(cambios).length > 0) {
        const historialRef = collection(db, 'usuarios', uid, 'historialFichas');
        const q = query(historialRef, orderBy('creadaEn', 'asc'));
        const snapHist = await getDocs(q);

        if (snapHist.size >= MAX_HISTORIAL) {
          const aBorrar = snapHist.docs.slice(0, snapHist.size - MAX_HISTORIAL + 1);
          for (const d of aBorrar) {
            await deleteDoc(d.ref);
          }
        }

        await addDoc(historialRef, {
          cambios,
          creadaEn: serverTimestamp(),
          origen: 'usuario'
        });
      }

      await updateDoc(userRef, {
        fichaActual: {
          ...datos,
          actualizadaEn: serverTimestamp()
        }
      });

      setMensajeExito(true);
      setTimeout(() => setMensajeExito(false), 3500);
    } catch (err) {
      console.error(err);
      setError('Ocurrió un error al guardar los cambios.');
    } finally {
      setGuardando(false);
    }
  };

  if (cargando) {
    return (
      <div style={ui.loaderBox}>
        <FaSpinner className="spin" size={28} color={APP_PRIMARY} />
        <span style={{ fontSize: '14px', color: '#64748b' }}>Cargando ficha del alumno...</span>
      </div>
    );
  }

  return (
    <div style={ui.container}>
      {/* Encabezado */}
      <div style={ui.header}>
        <span style={ui.badge}>Evaluación Inicial</span>
        <h2 style={ui.title}>Ficha Técnica del Alumno</h2>
        <p style={ui.subtitle}>
          Mantén tus datos físicos y de salud actualizados para adaptar tus planes con precisión.
        </p>
      </div>

      {error && <div style={ui.errorBanner}>{error}</div>}

      {/* 1. Motivo de uso */}
      <div style={ui.card}>
        <div style={ui.cardHeader}>
          <div style={ui.iconBox}><FaDumbbell size={16} color={APP_PRIMARY} /></div>
          <h3 style={ui.cardTitle}>Motivo de Entrenamiento</h3>
        </div>

        <div style={ui.field}>
          <label style={ui.label}>
            ¿Por qué quieres usar una aplicación fitness? <span style={ui.req}>*</span>
          </label>
          <select
            name="motivo"
            value={datos.motivo}
            onChange={handleChange}
            style={ui.select}
          >
            <option value="">Selecciona una opción</option>
            <option value="desmotivado">Estoy desmotivado con mi plan de entrenamiento</option>
            <option value="interesarEntrenador">Quiero mejorar mi rutina actual</option>
            <option value="principiante">Soy principiante y quiero aprender</option>
            <option value="sinDinero">No puedo pagar un entrenador presencial</option>
            <option value="noSeQueHacer">Quiero saber qué hacer en el gym</option>
            <option value="casa">Quiero aprender ejercicios para hacer en casa</option>
          </select>
        </div>
      </div>

      {/* 2. Datos Personales y Antropométricos */}
      <div style={ui.card}>
        <div style={ui.cardHeader}>
          <div style={ui.iconBox}><FaUser size={16} color={APP_PRIMARY} /></div>
          <h3 style={ui.cardTitle}>Datos Personales y Medidas</h3>
        </div>

        <div style={ui.grid2}>
          <div style={ui.field}>
            <label style={ui.label}>Nombre completo <span style={ui.req}>*</span></label>
            <input
              type="text"
              name="nombreCompleto"
              value={datos.nombreCompleto}
              onChange={handleChange}
              placeholder="Nombre y Apellido"
              style={ui.input}
            />
          </div>

          <div style={ui.field}>
            <label style={ui.label}>Correo electrónico <span style={ui.req}>*</span></label>
            <input
              type="email"
              name="email"
              value={datos.email}
              readOnly
              style={{ ...ui.input, backgroundColor: '#f8fafc', color: '#64748b' }}
            />
          </div>

          <div style={ui.field}>
            <label style={ui.label}>Género <span style={ui.req}>*</span></label>
            <select name="genero" value={datos.genero} onChange={handleChange} style={ui.select}>
              <option value="">Selecciona tu género</option>
              <option value="femenino">Femenino</option>
              <option value="masculino">Masculino</option>
              <option value="otro">Otro</option>
              <option value="prefieroNoDecir">Prefiero no decir</option>
            </select>
          </div>

          <div style={ui.field}>
            <label style={ui.label}>Edad <span style={ui.req}>*</span></label>
            <input
              type="number"
              name="edad"
              min="0"
              value={datos.edad}
              onChange={handleChange}
              placeholder="Ej: 26"
              style={ui.input}
            />
          </div>

          <div style={ui.field}>
            <label style={ui.label}>Peso actual (kg) <span style={ui.req}>*</span></label>
            <input
              type="number"
              name="peso"
              min="0"
              step="0.1"
              value={datos.peso}
              onChange={handleChange}
              placeholder="Ej: 65.5"
              style={ui.input}
            />
          </div>

          <div style={ui.field}>
            <label style={ui.label}>Altura (cm) <span style={ui.req}>*</span></label>
            <input
              type="number"
              name="altura"
              min="0"
              value={datos.altura}
              onChange={handleChange}
              placeholder="Ej: 165"
              style={ui.input}
            />
          </div>

          <div style={ui.field}>
            <label style={ui.label}>IMC <span style={ui.hint}>(opcional)</span></label>
            <input
              type="text"
              name="imc"
              value={datos.imc}
              onChange={handleChange}
              placeholder="Calcula o ingresa tu IMC"
              style={ui.input}
            />
          </div>

          <div style={ui.field}>
            <label style={ui.label}>Circunferencia cintura (cm) <span style={ui.hint}>(opcional)</span></label>
            <input
              type="number"
              name="circunferenciaCintura"
              value={datos.circunferenciaCintura}
              onChange={handleChange}
              placeholder="Ej: 75"
              style={ui.input}
            />
          </div>

          <div style={ui.field}>
            <label style={ui.label}>Horas de sueño al día <span style={ui.req}>*</span></label>
            <input
              type="number"
              name="horasSueno"
              min="0"
              max="24"
              value={datos.horasSueno}
              onChange={handleChange}
              placeholder="Ej: 8"
              style={ui.input}
            />
          </div>

          <div style={ui.field}>
            <label style={ui.label}>Actividad / Ocupación <span style={ui.req}>*</span></label>
            <input
              type="text"
              name="actividadOcupacion"
              value={datos.actividadOcupacion}
              onChange={handleChange}
              placeholder="Ej: Trabajo de oficina / Estudiante"
              style={ui.input}
            />
          </div>
        </div>

        <div style={{ ...ui.field, marginTop: '8px' }}>
          <label style={ui.label}>Objetivos principales detallados <span style={ui.req}>*</span></label>
          <textarea
            name="objetivos"
            rows="3"
            value={datos.objetivos}
            onChange={handleChange}
            placeholder="Describe tus expectativas, metas y lo que buscas lograr..."
            style={ui.textarea}
          />
        </div>
      </div>

      {/* 3. Salud y Antecedentes Médicos */}
      <div style={ui.card}>
        <div style={ui.cardHeader}>
          <div style={{ ...ui.iconBox, background: '#fef2f2' }}>
            <FaHeartbeat size={16} color="#ef4444" />
          </div>
          <h3 style={ui.cardTitle}>Salud y Antecedentes Médicos</h3>
        </div>

        <div style={ui.grid2}>
          <div style={ui.field}>
            <label style={ui.label}>¿Accidentes, cirugías u hospitalizaciones? <span style={ui.req}>*</span></label>
            <select name="antecedentesMedicos" value={datos.antecedentesMedicos} onChange={handleChange} style={ui.select}>
              <option value="">Selecciona</option>
              <option value="si">Sí</option>
              <option value="no">No</option>
            </select>
          </div>

          {datos.antecedentesMedicos === 'si' && (
            <div style={ui.field}>
              <label style={ui.label}>Especifica antecedentes <span style={ui.req}>*</span></label>
              <input
                type="text"
                name="especificarAntecedentes"
                value={datos.especificarAntecedentes}
                onChange={handleChange}
                placeholder="Ej: Cirugía de menisco año 2021"
                style={ui.input}
              />
            </div>
          )}

          <div style={ui.field}>
            <label style={ui.label}>¿Tomas medicamentos recurrentes? <span style={ui.req}>*</span></label>
            <select name="medicamentos" value={datos.medicamentos} onChange={handleChange} style={ui.select}>
              <option value="">Selecciona</option>
              <option value="si">Sí</option>
              <option value="no">No</option>
            </select>
          </div>

          {datos.medicamentos === 'si' && (
            <div style={ui.field}>
              <label style={ui.label}>Especifica medicamentos <span style={ui.req}>*</span></label>
              <input
                type="text"
                name="especificarMedicamentos"
                value={datos.especificarMedicamentos}
                onChange={handleChange}
                placeholder="Ej: Eutirox, Antialérgico"
                style={ui.input}
              />
            </div>
          )}

          <div style={ui.field}>
            <label style={ui.label}>¿Tienes alguna alergia conocida? <span style={ui.req}>*</span></label>
            <select name="tieneAlergia" value={datos.tieneAlergia} onChange={handleChange} style={ui.select}>
              <option value="">Selecciona</option>
              <option value="si">Sí</option>
              <option value="no">No</option>
            </select>
          </div>

          {datos.tieneAlergia === 'si' && (
            <div style={ui.field}>
              <label style={ui.label}>Especifica alergia <span style={ui.req}>*</span></label>
              <input
                type="text"
                name="especificarAlergia"
                value={datos.especificarAlergia}
                onChange={handleChange}
                placeholder="Ej: Polvo, mariscos, penicilina"
                style={ui.input}
              />
            </div>
          )}

          <div style={ui.field}>
            <label style={ui.label}>¿Consumes alcohol? <span style={ui.req}>*</span></label>
            <select name="bebeAlcohol" value={datos.bebeAlcohol} onChange={handleChange} style={ui.select}>
              <option value="">Selecciona</option>
              <option value="no">No</option>
              <option value="aVeces">A veces / Ocasional</option>
              <option value="si">Sí frecuente</option>
            </select>
          </div>

          <div style={ui.field}>
            <label style={ui.label}>¿Fumas tabaco? <span style={ui.req}>*</span></label>
            <select name="fuma" value={datos.fuma} onChange={handleChange} style={ui.select}>
              <option value="">Selecciona</option>
              <option value="no">No</option>
              <option value="aVeces">A veces / Ocasional</option>
              <option value="si">Sí</option>
            </select>
          </div>
        </div>

        {/* Problemas Posturales */}
        <div style={{ marginTop: '16px' }}>
          <label style={{ ...ui.label, marginBottom: '12px', display: 'block' }}>
            Condiciones o problemas posturales que identifiques:
          </label>
          <div style={ui.checkGrid}>
            {[
              { name: 'escoliosis', label: 'Escoliosis' },
              { name: 'cifosis', label: 'Cifosis' },
              { name: 'hiperlordosis', label: 'Hiperlordosis' },
              { name: 'ptosisAbdominal', label: 'Ptosis abdominal' },
              { name: 'toraxEscavado', label: 'Tórax excavado' },
              { name: 'escapulasAladas', label: 'Escápulas aladas' },
              { name: 'rodillasEnX', label: 'Rodillas en X' },
              { name: 'piePlano', label: 'Pie plano' },
              { name: 'pieCavo', label: 'Pie cavo' },
              { name: 'diferenciaExtremidades', label: 'Diferencia extremidades' }
            ].map((item) => {
              const checked = datos.problemasPosturales[item.name];
              return (
                <label
                  key={item.name}
                  style={{
                    ...ui.checkCard,
                    borderColor: checked ? APP_PRIMARY : '#e2e8f0',
                    backgroundColor: checked ? '#fdf2f8' : '#ffffff'
                  }}
                >
                  <input
                    type="checkbox"
                    name={item.name}
                    checked={checked}
                    onChange={handlePosturalChange}
                    style={{ accentColor: APP_PRIMARY, cursor: 'pointer' }}
                  />
                  <span style={{ fontSize: '13px', fontWeight: checked ? '600' : '500', color: checked ? APP_PRIMARY : '#334155' }}>
                    {item.label}
                  </span>
                </label>
              );
            })}

            <label
              style={{
                ...ui.checkCard,
                borderColor: datos.problemasPosturales.otrosPosturales ? APP_PRIMARY : '#e2e8f0',
                backgroundColor: datos.problemasPosturales.otrosPosturales ? '#fdf2f8' : '#ffffff'
              }}
            >
              <input
                type="checkbox"
                name="otrosPosturales"
                checked={datos.problemasPosturales.otrosPosturales}
                onChange={handlePosturalChange}
                style={{ accentColor: APP_PRIMARY, cursor: 'pointer' }}
              />
              <span style={{ fontSize: '13px', fontWeight: datos.problemasPosturales.otrosPosturales ? '600' : '500', color: datos.problemasPosturales.otrosPosturales ? APP_PRIMARY : '#334155' }}>
                Otros
              </span>
            </label>
          </div>

          {datos.problemasPosturales.otrosPosturales && (
            <div style={{ ...ui.field, marginTop: '12px' }}>
              <label style={ui.label}>Especifica otras condiciones posturales: <span style={ui.req}>*</span></label>
              <input
                type="text"
                name="descripcionOtrosPosturales"
                value={datos.problemasPosturales.descripcionOtrosPosturales}
                onChange={handlePosturalChange}
                placeholder="Describe tu condición postural..."
                style={ui.input}
              />
            </div>
          )}
        </div>
      </div>

      {/* 4. Actividad Física y Deporte */}
      <div style={ui.card}>
        <div style={ui.cardHeader}>
          <div style={{ ...ui.iconBox, background: '#f0fdf4' }}>
            <FaDumbbell size={16} color="#16a34a" />
          </div>
          <h3 style={ui.cardTitle}>Experiencia y Actividad Deportiva</h3>
        </div>

        <div style={ui.grid2}>
          <div style={ui.field}>
            <label style={ui.label}>¿Practicas o practicaste algún deporte? <span style={ui.req}>*</span></label>
            <select name="practicaDeporte" value={datos.practicaDeporte} onChange={handleChange} style={ui.select}>
              <option value="">Selecciona una opción</option>
              <option value="siRegular">Sí, regularmente</option>
              <option value="siOcasional">Sí, de vez en cuando</option>
              <option value="no">No practico</option>
            </select>
          </div>

          {(datos.practicaDeporte === 'siRegular' || datos.practicaDeporte === 'siOcasional') && (
            <div style={ui.field}>
              <label style={ui.label}>Deportes y frecuencia semanal <span style={ui.req}>*</span></label>
              <input
                type="text"
                name="detalleDeporteFrecuencia"
                value={datos.detalleDeporteFrecuencia}
                onChange={handleChange}
                placeholder="Ej: Pádel 2 veces por semana, running fines de semana"
                style={ui.input}
              />
            </div>
          )}

          <div style={ui.field}>
            <label style={ui.label}>Experiencia en entrenamiento de fuerza / pesas <span style={ui.req}>*</span></label>
            <select name="experienciaPesas" value={datos.experienciaPesas} onChange={handleChange} style={ui.select}>
              <option value="">Selecciona tu nivel</option>
              <option value="sinExperiencia">Sin experiencia previa (Nuevo/a)</option>
              <option value="principiante">Principiante (1 a 6 meses)</option>
              <option value="intermedio">Intermedio (6 meses a 2 años)</option>
              <option value="avanzado">Avanzado (Más de 2 años continuos)</option>
            </select>
          </div>

          <div style={ui.field}>
            <label style={ui.label}>Enfoque de entrenamiento deseado <span style={ui.req}>*</span></label>
            <select name="objetivoEntrenamiento" value={datos.objetivoEntrenamiento} onChange={handleChange} style={ui.select}>
              <option value="">Selecciona objetivo</option>
              <option value="crecerTonificar">Tonificación y ganancia de masa muscular</option>
              <option value="mejorEntrenamiento">Mejorar técnica, postura y fuerza general</option>
              <option value="mejorarAcondicionamiento">Acondicionamiento físico, resistencia y salud</option>
            </select>
          </div>
        </div>
      </div>

      {/* 5. Hábitos Nutricionales */}
      <div style={ui.card}>
        <div style={ui.cardHeader}>
          <div style={{ ...ui.iconBox, background: '#eff6ff' }}>
            <FaUtensils size={15} color="#2563eb" />
          </div>
          <h3 style={ui.cardTitle}>Hábitos de Alimentación</h3>
        </div>

        <div style={ui.grid2}>
          <div style={ui.field}>
            <label style={ui.label}>¿Tienes atención con Nutricionista? <span style={ui.req}>*</span></label>
            <select name="nutricionista" value={datos.nutricionista} onChange={handleChange} style={ui.select}>
              <option value="">Selecciona</option>
              <option value="tengoNutricionista">Sí, tengo actualmente</option>
              <option value="piensoBuscarNutricionista">Pienso buscar hora pronto</option>
              <option value="noPeroQuieroInformacionNutricion">No, pero me gustaría recibir orientación</option>
            </select>
          </div>

          <div style={ui.field}>
            <label style={ui.label}>¿Interés o conocimiento en nutrición? <span style={ui.req}>*</span></label>
            <select name="interesNutricion" value={datos.interesNutricion} onChange={handleChange} style={ui.select}>
              <option value="">Selecciona</option>
              <option value="tengoInteres">Tengo bastante interés en aprender</option>
              <option value="yaPoseoConocimiento">Ya cuento con conocimientos</option>
              <option value="noTengoConocimiento">No tengo conocimientos previos</option>
            </select>
          </div>
        </div>

        <div style={{ marginTop: '16px' }}>
          <label style={{ ...ui.label, marginBottom: '12px', display: 'block' }}>
            ¿Cómo catalogas tus tiempos de comida habituales?
          </label>
          <div style={ui.grid2}>
            {['desayuno', 'almuerzo', 'once', 'cena', 'entreComidas'].map((meal) => {
              const nombres = {
                desayuno: 'Desayuno',
                almuerzo: 'Almuerzo',
                once: 'Once / Merienda',
                cena: 'Cena',
                entreComidas: 'Colaciones / Snacks'
              };
              return (
                <div key={meal} style={ui.field}>
                  <label style={{ ...ui.label, fontSize: '13px' }}>
                    {nombres[meal]} <span style={ui.req}>*</span>
                  </label>
                  <select
                    name={meal}
                    value={datos.comidas[meal]}
                    onChange={handleComidaChange}
                    style={ui.select}
                  >
                    <option value="">Selecciona cómo es</option>
                    <option value="noIngieroNada">No ingiero nada / Me lo salto</option>
                    <option value="algoRapido">Rápido (café, galleta, fruta)</option>
                    <option value="altoContenidoGrasaAzucarSal">Alto en ultraprocesados / azúcares</option>
                    <option value="alimentacionAdecuada">Adecuada (proteína, verduras, carbohidrato)</option>
                    <option value="comidaBalanceada">Balanceada y medida según plan</option>
                  </select>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* 6. Compromiso Semanal */}
      <div style={ui.card}>
        <div style={ui.cardHeader}>
          <div style={ui.iconBox}><FaCheck size={14} color={APP_PRIMARY} /></div>
          <h3 style={ui.cardTitle}>Compromiso y Seguimiento</h3>
        </div>

        <div style={ui.field}>
          <label style={ui.label}>
            ¿Deseas activar recordatorios semanales para mantener tu compromiso con las metas? <span style={ui.req}>*</span>
          </label>
          <select
            name="contratoSemanal"
            value={datos.contratoSemanal}
            onChange={handleChange}
            style={ui.select}
          >
            <option value="">Selecciona una opción</option>
            <option value="si">Sí, deseo seguimiento semanal</option>
            <option value="no">No por el momento</option>
          </select>
        </div>
      </div>

      {/* Botón de Guardar centrado y destacado */}
      <div style={ui.actionBox}>
        <button
          type="button"
          onClick={handleGuardar}
          disabled={guardando}
          style={ui.btnSubmit}
        >
          {guardando ? (
            <>
              <FaSpinner className="spin" size={16} /> Guardando cambios...
            </>
          ) : (
            'Guardar y Actualizar Ficha'
          )}
        </button>
      </div>

      {/* Toast Flotante Elegante */}
      {mensajeExito && (
        <div style={ui.toast}>
          <div style={ui.toastIcon}><FaCheck size={12} color="#ffffff" /></div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <strong style={{ fontSize: '13px', color: '#16a34a' }}>Ficha actualizada</strong>
            <span style={{ fontSize: '12px', color: '#475569' }}>Los cambios se guardaron con éxito</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default PerfilUsuario;

/* =========================================================================
   ESTILOS PREMIUM (Diseño limpio, delicado y responsive)
   ========================================================================= */
const ui = {
  container: {
    maxWidth: '820px',
    margin: '0 auto',
    padding: '12px 16px 120px 16px', // Espacio suficiente para no colisionar con el dock
    boxSizing: 'border-box',
    fontFamily: "'Poppins', sans-serif"
  },
  loaderBox: {
    padding: '60px 20px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '14px'
  },
  header: {
    textAlign: 'center',
    marginBottom: '26px'
  },
  badge: {
    display: 'inline-block',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.6px',
    textTransform: 'uppercase',
    color: APP_PRIMARY,
    background: '#fdf2f8',
    padding: '4px 12px',
    borderRadius: '20px',
    marginBottom: '8px'
  },
  title: {
    fontSize: '26px',
    fontWeight: '700',
    color: '#1e293b',
    margin: '0 0 6px 0',
    letterSpacing: '-0.3px'
  },
  subtitle: {
    fontSize: '14px',
    color: '#64748b',
    margin: 0,
    maxWidth: '540px',
    marginLeft: 'auto',
    marginRight: 'auto',
    lineHeight: 1.5
  },
  errorBanner: {
    backgroundColor: '#fef2f2',
    color: '#b91c1c',
    border: '1px solid #fecaca',
    padding: '12px 16px',
    borderRadius: '12px',
    fontSize: '14px',
    textAlign: 'center',
    marginBottom: '20px',
    fontWeight: '500'
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '18px',
    padding: '24px 22px',
    marginBottom: '20px',
    border: '1px solid #f1f5f9',
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.03)'
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '18px',
    paddingBottom: '12px',
    borderBottom: '1px solid #f8fafc'
  },
  iconBox: {
    width: '36px',
    height: '36px',
    borderRadius: '10px',
    backgroundColor: '#fdf2f8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  },
  cardTitle: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#1e293b',
    margin: 0
  },
  grid2: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: '16px'
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  },
  label: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#475569',
    letterSpacing: '0.1px'
  },
  req: {
    color: APP_PRIMARY,
    fontWeight: '700'
  },
  hint: {
    fontSize: '11px',
    color: '#94a3b8',
    fontWeight: 'normal'
  },
  input: {
    width: '100%',
    padding: '11px 14px',
    borderRadius: '12px',
    border: '1.5px solid #e2e8f0',
    fontSize: '14px',
    color: '#1e293b',
    backgroundColor: '#ffffff',
    outline: 'none',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease'
  },
  select: {
    width: '100%',
    padding: '11px 14px',
    borderRadius: '12px',
    border: '1.5px solid #e2e8f0',
    fontSize: '14px',
    color: '#1e293b',
    backgroundColor: '#ffffff',
    outline: 'none',
    cursor: 'pointer',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    transition: 'border-color 0.2s ease'
  },
  textarea: {
    width: '100%',
    padding: '12px 14px',
    borderRadius: '12px',
    border: '1.5px solid #e2e8f0',
    fontSize: '14px',
    color: '#1e293b',
    backgroundColor: '#ffffff',
    outline: 'none',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    resize: 'vertical'
  },
  checkGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: '10px'
  },
  checkCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '10px 14px',
    borderRadius: '12px',
    border: '1.5px solid #e2e8f0',
    cursor: 'pointer',
    transition: 'all 0.2s ease'
  },
  actionBox: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '28px'
  },
  btnSubmit: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    backgroundColor: APP_PRIMARY,
    color: '#ffffff',
    border: 'none',
    borderRadius: '50px',
    padding: '14px 34px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 6px 18px rgba(176, 48, 96, 0.28)',
    transition: 'transform 0.15s ease, box-shadow 0.15s ease',
    outline: 'none'
  },
  toast: {
    position: 'fixed',
    bottom: '90px',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: '#ffffff',
    padding: '10px 20px',
    borderRadius: '50px',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.15)',
    border: '1px solid #e2e8f0',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    zIndex: 10001
  },
  toastIcon: {
    backgroundColor: '#16a34a',
    color: '#ffffff',
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};